import { DealStatus, sendConfirmationLink, setSafeDealResult } from '@/api/fns'
import axios from 'axios'
import { ActionContext } from 'vuex'

export interface ServiceProvidedConfirmationState {
  isLoading: boolean
  isSendingConfirmationLink: boolean
  error: string | null
}

export default {
  namespaced: true,

  state: <ServiceProvidedConfirmationState>{
    isLoading: false,
    isSendingConfirmationLink: false,
    error: null,
  },

  mutations: {
    setLoading(state: ServiceProvidedConfirmationState, isLoading: boolean) {
      state.isLoading = isLoading
    },
    setSendingConfirmationLink(
      state: ServiceProvidedConfirmationState,
      isSending: boolean,
    ) {
      state.isSendingConfirmationLink = isSending
    },
    setError(state: ServiceProvidedConfirmationState, error: string | null) {
      state.error = error
    },
  },

  actions: {
    async confirmServiceProvided(
      { commit }: ActionContext<ServiceProvidedConfirmationState, unknown>,
      { invoiceInternalId, token }: { invoiceInternalId: string; token: string },
    ) {
      try {
        commit('setLoading', true)
        await setSafeDealResult(invoiceInternalId, DealStatus.APPROVED, token)
        commit('setLoading', false)

        return 'success'
      } catch (error) {
        console.log('🚀 ~ confirmServiceProvided ~ error:', error)

        commit('setLoading', false)
        if (axios.isAxiosError(error) && error.response) {
          return error.response.data.error
        }

        return 'unknownError'
      }
    },

    async rejectServiceProvided(
      { commit }: ActionContext<ServiceProvidedConfirmationState, unknown>,
      { invoiceInternalId, token }: { invoiceInternalId: string; token: string },
    ) {
      try {
        commit('setLoading', true)
        await setSafeDealResult(invoiceInternalId, DealStatus.REJECTED, token)
        commit('setLoading', false)

        return 'success'
      } catch (error) {
        console.log('🚀 ~ confirmServiceProvided ~ error:', error)

        commit('setLoading', false)
        if (axios.isAxiosError(error) && error.response) {
          return error.response.data.error
        }

        return 'unknownError'
      }
    },

    async sendConfirmationLink(
      { commit }: ActionContext<ServiceProvidedConfirmationState, unknown>,
      { invoiceInternalId }: { invoiceInternalId: string },
    ) {
      try {
        commit('setSendingConfirmationLink', true)

        await sendConfirmationLink(invoiceInternalId)

        commit('setSendingConfirmationLink', false)

        return true
      } catch (error) {
        console.log('🚀 ~ sendConfirmationLink ~ error:', error)

        commit('setSendingConfirmationLink', false)

        return false
      }
    },
  },
}
